import { render } from "./HivePhotoSliderFullScreen.vue?vue&type=template&id=6a8d842f"
import script from "./HivePhotoSliderFullScreen.vue?vue&type=script&lang=js"
export * from "./HivePhotoSliderFullScreen.vue?vue&type=script&lang=js"
script.render = render

export default script